.content {
  display: flex;
  flex-direction: column;
  gap: 35px;
}